const font = {
	family: null,
	size: null
};
const flag = {
	background: {
		color: '#555'
	},
	color: '#FFF',
	font,
	padding: 3, // fallback padding if not specified elsewhere
	shapeType: 'polygon', // polygon, rectangle
	polygon: {
		yAxis: {
			left: { // style for left YAxis
				label: {
					padding: {
						top: null,
						right: 0, // the default YAxis font size (11px) looks better with 0 here (because the pointer effectively is the padding). Larger fonts may need more right padding.
						bottom: null,
						left: null
					}
				}
			},
			right: { // style for right YAxis
				label: {
					padding: {
						top: null,
						right: null,
						bottom: null,
						left: 0 // the default YAxis font size (11px) looks better with 0 here (because the pointer effectively is the padding). Larger fonts may need more left padding.
					}
				}
			}
		},
		pointer: {
			height: null, // if null, automatically draw to flag's body height (the rectangle portion)
			width: 8
		}
	},
	rectangle: {
		radius: {
			x: 2,
			y: 2
		},
		yAxis: {
			left: { // style for left YAxis
				label: {
					padding: {
						top: null,
						right: null,
						bottom: null,
						left: 5
					}
				}
			},
			right: { // style for right YAxis
				label: {
					padding: {
						top: null,
						right: 5,
						bottom: null,
						left: null
					}
				}
			}
		}
	}
};

export default {
	crosshair: {
		xAxis: flag,
		yAxis: flag
	},
	horizontalAnnotation: flag,
	indicator: flag,
	lastClose: flag
};
